module.exports = __webpack_public_path__ + "static/rick-009-711ea78449ec20b7dd540534a392be91.jpg";